import { setHiddenTaxRateApi } from "@/api/services/global/master";
import { TGetTaxRateListOutputDto } from "@/api/services/global/master/dtos/taxRate/get-master-tax-rate-list.dto";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenTaxRateModalProps = {
  hiddenTaxRate?: TGetTaxRateListOutputDto;
  setHiddenTaxRate: Dispatch<SetStateAction<TGetTaxRateListOutputDto | undefined>>;
};

export const HiddenTaxRateModal: FC<THiddenTaxRateModalProps> = ({ hiddenTaxRate, setHiddenTaxRate }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenTaxRate) return;
    try {
      await setHiddenTaxRateApi(toNumber(hiddenTaxRate.id), { isHidden: !hiddenTaxRate.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenTaxRate(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_TAX_RATE] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenTaxRate?.isHidden ? "有効の確認" : "無効化の確認"}
      isOpen={!!hiddenTaxRate}
      onClose={() => setHiddenTaxRate(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenTaxRate?.isHidden ? "この行が有効になれますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
